import { SessionStorage } from './session-storage.service'

const isSessionStorageSupported = () => {
  const testKey = `___session-storage-testing-key___${Math.random()}`
  try {
    window.sessionStorage.setItem(testKey, testKey)
    window.sessionStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

export const sessionStorageFactory = () => {
  if (isSessionStorageSupported()) {
    return window.sessionStorage
  }

  return new SessionStorage()
}
